module.exports = __webpack_public_path__ + "img/IAR1.534297bc.png";